import {
  formDataRequest,
  getRequest,
  postRequest,
} from "../libs/AxiosService.util";

export async function serviceCreateStateMember(params) {
  return await formDataRequest("chapters/state/create", params);
}
export async function serviceUpdateStateMember(params) {
  return await formDataRequest("chapters/state/update", params);
}
export async function serviceDeleteStateMember(params) {
  return await postRequest("chapters/state/delete", params);
}
export async function serviceGetStateMemberDetails(params) {
  return await postRequest("chapters/state/detail", params);
}
export async function serviceGetStateMember(params) {
  return await postRequest("chapters/members/users", params);
}
export async function serviceDetailsStateMember(params) {
  return await postRequest("chapters/state/detail", params);
}
export async function serviceCheckStateMember(params) {
  return await postRequest("chapters/state/exists", params);
}

export async function serviceStateMemberDownload(params) {// 
  return await postRequest("chapters/state/member/exports", params);
}

export async function serviceChapterActiveStateMemberDownload(params) {// 
  return await postRequest("chapters/state/active/member/exports  ", params);
}

export async function serviceStateMemberDownloadCity(params) {// 
  return await postRequest("chapters/city/member/exports", params);
}
export async function serviceStateMemberDownloadCityAssociation(params) {// 
  return await postRequest("chapters/city/association", params);
}

export async function serviceStateMemberDownloadUser(params) {// 
  return await postRequest("users/export", params);
}
export async function serviceStateMemberDownloadFederation(params) {// 
  return await postRequest("chapters/state/exports", params);
}